import axios from 'axios'
import compose from 'compose-function'

import { getAccessKey } from '@/lib/accessKey'
import { axiosAuth } from '@/lib/axiosAuth'
import { axiosLog } from '@/lib/axiosLog'
import type { Logger } from '@/lib/logger'
import type { GetAccessToken } from '@/utils/authentication'

import type { JwtValidatorApiService } from './services/jwtValidator'
import createJwtValidatorService from './services/jwtValidator'

interface VouchApiService {
  jwtValidator: JwtValidatorApiService
}

const createVouchApiService = (
  logger: Logger,
  getAccessToken: GetAccessToken,
): VouchApiService => {
  const accessKey = getAccessKey()
  const apiClient = compose(
    axiosLog(logger, 'Vouch'),
    axiosAuth(() => getAccessToken(logger)),
  )(
    axios.create({
      baseURL: `${import.meta.env.VITE_VOUCH_API}/`,
      headers: {
        'Ocp-Apim-Subscription-Key': accessKey,
      },
    }),
  )

  return {
    jwtValidator: createJwtValidatorService(apiClient),
  }
}

export default createVouchApiService
